import { AlertTriangle } from "lucide-react";
import { useSystemConfig } from "../../hooks/useAssets";

/**
 * Shown wherever an asset number is about to leave the system on paper.
 *
 * Until the system-wide freeze (docs/adr/0001) an asset's number follows its
 * entity, category and entity acquisition year, so a printed number can go
 * stale. The QR code is unaffected — it encodes the asset id, not the number —
 * but the human-readable number on the sticker is not permanent yet.
 * Renders nothing once numbers are frozen.
 */
export function ProvisionalNumberWarning({ className = "" }) {
  const { data: config } = useSystemConfig();
  if (!config || config.assetNumbersFrozen) return null;

  return (
    <div
      className={`flex gap-2 rounded-lg border border-amber-200 bg-amber-50 px-3 py-2 text-xs text-amber-800 ${className}`}
    >
      <AlertTriangle className="h-4 w-4 shrink-0 mt-px" />
      <p>
        <strong>Asset numbers are still provisional.</strong> A printed number
        can change when an asset's entity, category or entity acquisition date
        is corrected, or when another asset in the same group is added or
        moved, which would leave the sticker out of date. The QR code stays
        valid.
      </p>
    </div>
  );
}
